import type { HeadingTokens } from './types';

export const heading: HeadingTokens = {
  letterSpacings: {
    1: 'bitCondensed',
    2: 'bitCondensed',
    3: 'bitCondensed',
    4: 'bitCondensed',
    5: 'bitCondensed',
    6: 'bitCondensed',
  },
};
